import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class ToastHelperService {
    constructor(
        private toastr: ToastrService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    private get canShow() { return isPlatformBrowser(this.platformId); }

    success(msg: string, title?: string) { if (this.canShow) this.toastr.success(msg, title); }
    error(msg: string, title?: string) { if (this.canShow) this.toastr.error(msg, title); }
    info(msg: string, title?: string) { if (this.canShow) this.toastr.info(msg, title); }
    warn(msg: string, title?: string) { if (this.canShow) this.toastr.warning(msg, title); }
}